import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "./../../../environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Proveedor } from "./proveedorModel";

@Injectable({
  providedIn: "root",
})
export class ProveedoresService {
  constructor(private http: HttpClient) {}

  getTiposPersona() {
     return this.http.get<any>(`${environment.urlProveedores}/CargarComboTiposPersona`);
  }

  getTiposDocumento(){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboTiposDoc`);
  }

  getProvincias(){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboProvincias`);
  }

  getRubros(){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboTiposRubro`);
  }

  getTiposBenef(){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboTiposBenef`)
  }

  cargarCatBenef(tipoBenef : number){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboCatTiposBenef/${tipoBenef}`);
  }

  cargarDepartamentos(provincia : number){
    return this.http.get<any>(`${environment.urlProveedores}/CargarComboDepartamentos/${provincia}`);
  }

  addProveedor(data : Proveedor):Observable<any>{
    return this.http.post<any>(`${environment.urlProveedores}/InsertarProveedor`,data);
  }

  

  // addProveedor(data): Observable<Response> {
  //   return this.http
  //     .post(`${environment.urlProveedores}/InsertarProveedor`, data)
  //     .pipe(map((response: any) => response));
  // }

}

